import { render, staticRenderFns } from "./CodeField.vue?vue&type=template&id=0dab2d37&scoped=true"
import script from "./CodeField.vue?vue&type=script&lang=js"
export * from "./CodeField.vue?vue&type=script&lang=js"
import style0 from "./CodeField.vue?vue&type=style&index=0&id=0dab2d37&prod&lang=css"
import style1 from "./CodeField.vue?vue&type=style&index=1&id=0dab2d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab2d37",
  null
  
)

export default component.exports